import SelectedKeywords from './SelectedKeywords';
import './SelectedKeywords.scss';

export default SelectedKeywords;